// Server-side calls run inside the container, where the browser-facing
// NEXT_PUBLIC_API_BASE_URL (localhost) isn't the backend. INTERNAL_API_URL is
// the in-cluster host and is undefined in the browser, so client callers fall
// through to the public URL automatically.
const API_BASE =
  process.env.INTERNAL_API_URL ||
  process.env.NEXT_PUBLIC_API_BASE_URL ||
  'http://localhost:4000';

export type PublishedBlogCard = {
  id: string;
  title: string;
  slug: string;
  featuredImage: string | null;
  publishedAt: string | null;
};

/** Published blog posts for storefront (homepage, rails). Server order is newest `publishedAt` first. */
export async function fetchPublishedBlogCards(limit: number): Promise<PublishedBlogCard[]> {
  const pageSize = Math.min(100, Math.max(1, limit));
  try {
    const res = await fetch(`${API_BASE}/api/pages?kind=BLOG&pageSize=${pageSize}&page=1`, {
      cache: 'no-store',
    });
    if (!res.ok) return [];
    const data = await res.json();
    if (!data?.success || !Array.isArray(data.pages)) return [];
    return data.pages.map((item: any) => ({
      id: item.id,
      title: item.title || 'Untitled',
      slug: item.slug,
      featuredImage: item.featuredImage ?? null,
      publishedAt: item.publishedAt ?? null,
    })).filter((row: PublishedBlogCard) => Boolean(row.slug));
  } catch {
    return [];
  }
}
